import { 
  Box, 
  Typography, 
  Paper, 
  Button, 
  Divider, 
  Stack, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StudentProfileCard from './StudentProfileCard';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const EnrollmentIntro = ({ introStudent, setPage, enrollment }) => {
  const [modalOpen, setModalOpen] = useState(true);
  const schoolName = enrollment?.applicationSchool?.school?.name
  const registrarInformation = enrollment?.applicationSchool?.school?.campuses[0]?.person
  const schoolAddress = `${enrollment?.applicationSchool?.school?.campuses[0]?.address?.street}, ${enrollment?.applicationSchool?.school?.campuses[0]?.address?.city.trim()}, ${enrollment?.applicationSchool?.school?.campuses[0]?.address?.state} ${enrollment?.applicationSchool?.school?.campuses[0]?.address?.zip}`
  const schoolPhone = enrollment?.applicationSchool?.school?.campuses[0]?.phone?.number
  if (enrollment?.finalized) setPage("form");
  const { t } = useTranslation();

  return (
    <Box width="100% !important" sx={{ mt: 2, mb: 2 }}>
      <Dialog open={modalOpen}>
        <DialogTitle sx={{ fontWeight: 700 }}>
          {t("This form is for authorized parent or guardian only")}
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            {t("I hereby consent that I am authorized to complete the application for")} <b>{introStudent?.firstName} {introStudent?.lastName}</b> {t("who has been accepted and I will provide any proof of documentation that is required.")}.
          </Typography>
          <Typography variant="body2" color="warning.main" sx={{ fontWeight: 600 }}>
            {t("Please note: You must finish this application in one sitting. Unsaved progress may be lost.")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} variant="contained" color="primary">
            {t("I Understand")}
          </Button>
        </DialogActions>
      </Dialog>

      <Paper 
        elevation={0} 
        variant="outlined" 
        sx={{ borderRadius: 3, overflow: 'hidden' }}
      >
        <Box 
          sx={{ 
            bgcolor: 'primary.main', 
            color: 'primary.contrastText', 
            p: 4,
            backgroundImage: 'linear-gradient(45deg, rgba(0,0,0,0.05) 25%, transparent 25%, transparent 50%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.05) 75%, transparent 75%, transparent)',
            backgroundSize: '20px 20px'
          }}
        >
          <Box display="flex" alignItems="center" gap={2} mb={1}>
            <Typography variant="h5" fontWeight="bold">
              {t("Enrollment Form Instructions")}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ p: 4 }}>
          <Typography variant="h6" gutterBottom>
            {t("Dear Parent/Guardian,")}
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph sx={{ lineHeight: 1.7 }}>
            {t("Congratulations on your childs acceptance to")} <b>{schoolName}</b>.
            {t("Please complete the enrollment application accurately. It is imperative that all deadlines are met to ensure your child has a seat in the upcoming school year.")}
          </Typography>

          <Typography variant="body2" color="warning.main" sx={{ fontWeight: 600, mb: 2 }}>
            {t("Please note: You must finish this application in one sitting. Unsaved progress may be lost.")}
          </Typography>

          <Divider sx={{ my: 4 }} />
          
          <StudentProfileCard student={introStudent} />

            <Box sx={{ bgcolor: 'info.lighter', p: 2, borderRadius: 2 }}>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                {t("Questions? Contact the Registrar:")}
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block" >
                      {t("School Registrar")}
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {`${registrarInformation?.firstName || ""} ${registrarInformation?.lastName || "-"}`}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      {t("Registrar Email")}
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {registrarInformation?.email || "—"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      {t("School Phone")}
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {schoolPhone || "—"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      {t("School Address")}
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {schoolAddress || "—"}
                    </Typography>
                  </Box>
              </Stack>
            </Box>
        </Box>

        <Box 
          sx={{ 
            p: 3, 
            bgcolor: 'grey.50', 
            borderTop: '1px solid', 
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => setPage("form")}
            endIcon={<ArrowForwardIcon />}
            sx={{ fontWeight: 'bold' }}
          >
            {t("Start Enrollment Form")}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default EnrollmentIntro;